<div class="content-left-top-cornor">
  <div class="container-fluid mt-0">
  <div class="row" style="margin-top: 10px;" style="padding: 0px;">
    <div class="col-12 flex">
      <div class="col-3">
        <div class="col">
          <div class="row">
            <div class="col-10" id="multiselectDiv">
              <div class="ui-inputgroup" id="filterLabel">
                <button pButton class="theme-button noHover labelButton"  [style]="{'height':'74%'}" type="button" label="Filter"></button>
                <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter('')" [(ngModel)]="selectedStates"
                  id="multiselectStatuses" [style]="{'width':'67%', 'height':'74%'}">
                  <ng-template let-item pTemplate="selectedItem">
                    <span style="vertical-align:middle">{{item.label}}</span>
                  </ng-template>
                  <ng-template let-status pTemplate="item">
                    {{status.label}}
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
            <div class="col-2" id="refreshBatchesDiv">
              <button pButton style="width: 74%; height: 74%;" class="refreshBatches" icon="fa fa-refresh" (click)="onApplyFilter('')"></button>
            </div>
            <div class="row p-0" id="datePicker">
              <div class="col-6 p-0">
                <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter('')"
                  [inputStyle]="{'width':'70%','height':'100%'}" dateFormat="dd.mm.yy" [showIcon]="true" placeholder="From"
                  showButtonBar="true" (onClearClick)="onApplyFilter('clear')" (onTodayClick)="onApplyFilter('')"
                  [maxDate]="toDate"></p-calendar>
              </div>
              <div class="col-6 p-0">
                <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter('')"
                  [inputStyle]="{'width':'70%','height':'100%'}" dateFormat="dd.mm.yy" [showIcon]="true" placeholder="To"
                  showButtonBar="true" (onClearClick)="onApplyFilter('clear')" (onTodayClick)="onApplyFilter('')"></p-calendar>
              </div>
            </div>
            <div class="row col-12 flex" style=" margin-left: 1%;">
              <label class="m-0">Number Of Batches Matching Filter: <label class="m-0 font-weight-bold text-success"
                  style="font-size: 1.2rem;">{{batches == null ? 0: batches.length}}</label></label>
            </div>
            <p-table [value]="batches" selectionMode="single" [scrollable]="true" scrollHeight="80vh"
              (onRowSelect)="showBatchInfo($event)" (onRowUnselect)= "isCreate = true"[loading]="loading">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 40%;" class="batch" scope="col">Batch ID</th>
                  <th class="status" scope="col">Status</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-batch>
                <tr [pSelectableRow]="batch">
                  <td style="width: 40%;" [class]="batch?.rushSample == true ? 'rushBody pr-0' : 'normalBody pr-0'">
                    {{batch?.batchID}}</td>
                  <td [class]="batch?.rushSample == true ? 'rushBody pr-0' : 'normalBody pr-0'">{{batch?.statusOfTheBatch}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

        <div class="row" *ngIf="isRedoSamplesAvailable()">
          <button class="mt-3 mb-3 ml-auto mr-3" pButton icon="fa fa-download" type="button" label="Redo Samples"
            (click)="downloadSamples()"></button>

        </div>
        <div class="row" *ngIf="isRedoSamplesAvailable()">
          <p-table [value]="redoSampleSenders" selectionMode="single" [scrollable]="true"
            [loading]="loading">
            <ng-template pTemplate="header">
              <tr>
                <th class="batch" scope="col">Sender</th>
                <th class="status" scope="col">Redo Samples</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-redomapkey>
              <tr>
                <td>{{redomapkey}}</td>
                <td>{{getNoOfRedoSamplesForSender(redomapkey)}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        </div>
      </div>
      <div class="col-9">
        <div class="col-4" style="padding: 0% 0% 2% 0%;">
          <div class="ui-inputgroup userIdLable" style="margin-top: 10px;">
            <button pButton class="theme-button noHover labelButton" type="button" label="User ID"
              style="width: 44%;"></button>
            <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4"
              style="width: 50%; border-radius: 1px; height: 40px;" placeholder="User ID" />
          </div>
        </div>
          <div class="col-12" style="display: flex;">
            <div class="ui-inputgroup userIdLable" style="margin-top: 10px; display: flex;">
              <div style="width:44%">
                <p-dropdown [style]="{'width':'101%'}" placeholder="Choose Search" [options]="searchFilterList"
                  name="searchFilterList" [(ngModel)]="selectedSearchFilter">
                </p-dropdown>
              </div>
              <input pInputText name="SearchSample" [(ngModel)]="valueToSearch" size="17"
                (keydown.enter)="searchForBatchWIthFilter()" style="width: 50%; height: 40px;" />
              <button pButton icon="fa fa-search" style="width: 10%;height: 2.5rem;" [disabled]="searchButtonDisabledIf()"
                (click)="searchForBatchWIthFilter()">
              </button>
            </div>
         
      
          <div class="col-5 topDivspacing" style="text-align:left;margin: 0px 0px 3px;padding: 0% 0% 2%;">
            <div class="col-11 headers" style="height: 32px;">
              <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  Batch </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;padding: 2% 8%;" class="col-1">
                <h5>:</h5>
              </div>
              <div class="col-7">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedBatch?.batchID}}</strong>
                </h5>
              </div>
            </div>
            <div class="col-11 headers" style="height: 32px;">
              <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  Status </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;padding: 2% 8%;" class="col-1">
                <h5>:</h5>
              </div>
              <div class="col-7">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedBatch?.statusOfTheBatch}} </strong>
                </h5>
              </div>
            </div>
            <div class="col-11 headers" style="height: 32px;">
              <div class="col-3">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  Sender </h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;padding: 2% 8%;" class="col-1">
                <h5>:</h5>
              </div>
              <div class="col-7">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{getfunction()}} </strong>
                </h5>
              </div>
            </div>
            <div class="col-11 headers" style="height: 32px;">
              <div class="col-4">
                <h5 style="color:#1F89CE; font-size: 19px;width: 120px;">
                  External Id</h5>
              </div>
              <div style="color:#1F89CE; font-size: 19px;padding: 2% 0%;" class="col-1">
                <h5>:</h5>
              </div>
              <div class="col-7">
                <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedBatch?.externalIdentification}} </strong>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-2">
            <button pButton class="buttonsRound" id="templateDownload" icon="fa fa-download" label='Template (Internal)'
              (click)="getExcel()" [disabled]="!selectedBatch.statusOfTheBatch || selectedBatch.wellType == 'WELL384'"></button>
          </div>
        
        </div>
        <br>
        <div class="col-12 flex" id="tableDiv">

          <p-confirmDialog key="confirm-overwrite-sample" appendTo="body"></p-confirmDialog>
          <p-confirmDialog key="confirm-batchID" appendTo="body"></p-confirmDialog>

          <table id="batchTable" aria-describedby="Unboxing Table"
            style="border: 1px solid blue; width: 100%; height: 100%; table-layout: fixed;margin-top: -1.7%;">
            <thead id="batchTableHeader">
              <tr>
                <th style="width: 30%;" scope="col">Batch Creation</th>
                <th style="width: 70%;" scope="col">Scanning</th>
              </tr>
            </thead>
            <tbody id="batchTableBody">
              <tr>
                <td id="batchTableBody">
                  <div>
                    <div id="createNewBatchButtonDiv" style="width: 100%;">
                      <button pButton id="createNewBatchButton" label="New Batch" (click)="clearAllFieldsForNewBatch()"
                        class="noHover" style="margin-left: 25%;" class="buttonsRound startButton"></button>
                    </div>
                    <div class="ui-inputgroup batchIDField" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Sender"></button>
                      <p-dropdown [style]="{'width':'160px'}" placeholder="Sender" class="senderDropDown"
                        [options]="customerList"  name="customertList"
                        (onChange)="getSelectedSender()" [disabled]="isScanElementDisabled()"
                        [(ngModel)]="selectedBatch.sender">
                      </p-dropdown>
                    </div>
                    <div class="ui-inputgroup flex" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Batch ID"></button>
                      <div>
                        <input pInputText name="batchID" style="width: 160px; margin-right:5px; height: 96%;" placeholder="Batch ID" id="batchID"
                        [readOnly]="isScanElementDisabled()"
                        (blur)="checkBatchExistance(selectedBatch.batchID)"
                        [(ngModel)]="selectedBatch.batchID"
                        [disabled]="!isCreate" />
                      </div>
                      <button class="btn p-0 m-0" style="width: 8%;" [disabled]="printLabelDisabledIf()" (click)="printLabel()">
                        <em class="fa fa-print"></em>
                      </button>
                    </div>
                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" style="height:51px;"
                        label="External Identification"></button>
                      <input pInputText name="externalIdentification" style="width: 160px; height:3.2rem;" placeholder="External Identification"
                        [(ngModel)]="selectedBatch.externalIdentification" />
                    </div>
                    <div class="ui-inputgroup" id="inputClass">
                        <button pButton class="theme-button noHover labelButton" type="button"
                          label="CO Project ID"></button>
                        <input pInputText name="coProjectId" style="width: 160px; height:auto;" placeholder="CO Project ID"
                          [(ngModel)]="selectedBatch.coProjectId" />
                    </div>
                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button"
                        label="Regional Code"></button>
                      <input pInputText name="regionalCode" style="width: 160px; height:auto;" placeholder="Regional Code"
                        [(ngModel)]="selectedBatch.regionalCode" />
                    </div>
                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button"
                        label="Max Batch"></button>
                      <p-spinner name="barcodeQuantity" size="3" [(ngModel)]="selectedBatch.count" [min]="1" [max]="94"
                        required="true" [disabled]="!isCreate && (selectedBatch?.statusOfTheBatch!=='CREATE_BATCH')"></p-spinner>
                    </div>

                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Product"></button>
                      <p-dropdown [style]="{'width':'160px'}" placeholder="Product" class="senderDropDown"
                        [options]="productList"  name="productList" (onChange)="setRequiredRead(selectedBatch.product)"
                        disabled="{{productList.length == 0}}" [(ngModel)]="selectedBatch.product">
                      </p-dropdown>
                    </div>
                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button"
                        label="Required Reads"></button>
                      <input pInputText name="requiredRead" style="width: 160px;height:auto" placeholder="Required Read"
                       [ngModel]="selectedBatch.requiredRead" (ngModelChange)="selectedBatch.requiredRead=$event"/>
                    </div>
                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button"
                        label="Comment to Customer" style="height: 64px"></button>
                      <textarea pInputText [(ngModel)]="selectedBatch.orderReceptionComment" type="text" name="comment"
                        placeholder="" id="comment" rows="2" ></textarea>
                    </div>

                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button"
                        label="Rush Batch"></button>
                      <p-inputSwitch [(ngModel)]="selectedBatch.rushSample"></p-inputSwitch>
                    </div>

                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="NC Batch"></button>
                      <p-inputSwitch [(ngModel)]="selectedBatch.ncSample" (onChange)="disableSwab($event)"></p-inputSwitch>
                    </div>

                    <div *ngIf="isCreate" id="createBatchButtonDiv">
                      <div id="createdDateTime" style="margin-left:34%;">{{selectedBatch?.receptionDateTime | date: 'dd.MM.yy HH:mm'}}
                        {{selectedBatch?.puidUnboxing}}</div>
                      <button pButton id="createBatchButton" class="buttonsRound thirdButton" label="Create Batch"
                        [disabled]="createBatchDisabledIf()" (click)="saveBatch('CREATE_BATCH')"
                        style="margin-left:25%;"></button>
                    </div>

                    <div *ngIf="!isCreate" id="createBatchButtonDiv">
                        <div id="createdDateTime" style="margin-left:34%;">{{selectedBatch?.receptionDateTime | date: 'dd.MM.yy HH:mm'}}
                          {{selectedBatch?.puidUnboxing}}</div>
                        <button pButton id="createBatchButton" class="buttonsRound thirdButton" label="Update Batch"
                          [disabled]="createBatchDisabledIf()" (click)="saveBatch('')"
                          style="margin-left:25%;"></button>
                    </div>

                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Label Printer"></button>
                      <p-dropdown [style]="{'width':'160px'}" placeholder="Select Printer" class="senderDropDown"
                        [options]="printerList"  name="printerList" optionLabel="name" (onChange)="onSelectPrinter()"
                        [(ngModel)]="selectedPrinter">
                      </p-dropdown>
                    </div>

                    <div class="ui-inputgroup" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Label Template"></button>
                      <p-dropdown [style]="{'width':'160px'}" placeholder="Select Template" class="senderDropDown"
                        [options]="templateList" name="templateList" optionLabel="templateName"
                        [(ngModel)]="selectedTemplate">
                      </p-dropdown>
                    </div>

                    <div>
                      <button pButton id="createBatchButton" class="buttonsRound thirdButton" label="Print Labels"
                        [disabled]="printLabelDisabledIf()" (click)="printLabel()"
                        style="margin-left:25%;"></button>
                    </div>

                  </div>
                </td>
                <td id="processingTableBody">
                  <div id = "processingBodyContents">
                    <div class = "col-12 flex p-0">
                      <div  class = "col-4 ml-0 mr-0 mt-3 w-30 p-0 float-left" >
                        <p-fileUpload #fileUploaderCustomer [style]="getFileUploadStyle()" (onSelect)="onCustomerFileSelect($event)" (uploadHandler)="onExcelUpload($event, fileUploaderCustomer, true)" mode="basic"
                        customUpload="true" accept=".xls" chooseLabel="Upload Excel (Customer)" [disabled]="isUploadDisabled()" auto="true"></p-fileUpload>
                      </div>
                      <div  class = "col-4 ml-0 mr-0 mt-3 w-30 p-0" >
                        <p-fileUpload #fileUploaderInternal [style]="getFileUploadStyle()"  (onSelect)="onInternalFileSelect($event)" (uploadHandler)="onExcelUpload($event, fileUploaderInternal, false)" mode="basic"
                        customUpload="true" accept=".xlsm,.xlsx" chooseLabel="Upload Excel (Internal)" [disabled]="isUploadDisabled()" auto="true"></p-fileUpload>
                      </div>
                      <div  class = "col-4 ml-0 mr-0 mt-3 w-30 p-0 float-right" >
                        <button pButton  class="buttonsRoundWithoutMargin" label="Scan Plate"
                         [disabled]="scanPlateDisabled()" (click)="scanPlate()"></button>
                      </div>
                    </div>
                      <div class = "col-12 flex ml-0 mb-0 mr-0 mt-2 p-0">
                        <div class = "col-4  m-0 p-0">
                            Excel Name Uploaded
                        </div>
                        <div class = "col-1 m-0 p-0">
                          :
                        </div>
                        <div class = "col-4 m-0 p-0">
                            {{selectedBatch?.sampleUploadedFileName}}
                        </div>
                      </div>

                    <div>
                      <button pButton class="noHover labelButton" id='sampleCountButton'type="button"
                        label="Sample Count"></button>
                        &nbsp;
                        {{selectedBatch?.samples?.length}}
                    </div>
                    <div  *ngIf="!selectedBatch?.externalUpload">
                    <div class = "col-12 flex m-0 p-0 ">
                      <div class = "col-4  m-0 p-0">
                        Country
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div class = "col-4 m-0 p-0">
                        {{selectedBatch?.country}}
                      </div>
                    </div>
                    <div class = "col-12 flex m-0 p-0 pt-1">
                      <div class = "col-4  m-0 p-0">
                          Organization Name
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div class = "col-4 m-0 p-0">
                          {{selectedBatch?.organizationName}}
                      </div>
                    </div>
                    <div class = "col-12 flex m-0 p-0 pt-1">
                      <div class = "col-4 m-0 p-0">
                          Name of Contact Person
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div class = "col-4 m-0 p-0">
                          {{selectedBatch?.contactName}}
                      </div>
                    </div>
                    <div class = "col-12 flex m-0 p-0 pt-1">
                      <div class = "col-4 m-0 p-0">
                          Contact email Address
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div class = "col-4 m-0 p-0">
                        {{selectedBatch?.contactEmail}}
                      </div>
                    </div>
                    <div class = "col-12 flex m-0 p-0 pt-1">
                      <div class = "col-4 m-0 p-0">
                          Contact Phone Number
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div class = "col-4 m-0 p-0">
                        {{selectedBatch?.contactPhoneNumber}}
                      </div>
                    </div>
                    <div class = "col-12 flex m-0 p-0 pt-1">
                      <div class = "col-4 m-0 p-0">
                          Number of Plates per Shipment
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div class = "col-4 m-0 p-0">
                        {{selectedBatch?.numberOfPlatesPerShipment}}
                      </div>
                    </div>
                     </div>
                  <div  *ngIf="selectedBatch?.externalUpload && !isCustomer">
                    <div class = "col-12 flex m-0 p-0 " style="height: 5rem;">
                      <div class = "col-4  m-0 p-0">
                        Senders
                      </div>
                      <div class = "col-1 m-0 p-0">
                        :
                      </div>
                      <div *ngFor="let name of selectedBatch.senderName;let i = index;">
                        <div *ngIf="i==0" class = "col-4 m-0 p-0">
                        {{name}} </div>
                       <div *ngIf="i > 0" style="padding: 0% 41.75%;">
                        {{name}}
                       </div>
                      </div>
                    </div>

                    </div>
                    <div class="col-12 flex p-0" id="receiveBatchDiv">
                      <div class="col-8 p-0 font-weight-bold">
                        When the Samples have arrived in the lab:
                      </div>
                      <div class="col-4 p-0 text-right pr-2">
                        <button pButton class="theme-button buttonsRound thirdButton" type="button"
                        label="Batch Received" [disabled]="disableBatchReceieve()" (click)="receiveBatch('BATCH_RECEIVED')" ></button>
                      </div>
                    </div>
                  </div>
                </td>
  </tr>
  </tbody>
  </table>
</div>
</div>
</div>
  </div>

<p-dialog [(visible)]="nonConformVisible" [modal]="true" id="nonConformDialog"
  header="Non conforming sample {{selectedSamples[0]?.eurofinsBarcode}}" (onHide)="clearSelection()">
  <div class="ui-inputgroup">
    <p-checkbox id="sampleAnalysisCheckBox" [(ngModel)]="canAnalyze" [binary]="true" [disabled]="problem == 'sampleOk'">
    </p-checkbox>
    Sample Can be Analysed
  </div>
  <div class="ui-inputgroup" id="sampleCauseDropDown">
    <button pButton class="theme-button noHover labelButton" type="button" label="Problems"></button>
    <p-dropdown placeholder="Problems"  name="problemList" [(ngModel)]="problem"
      [options]="problemOptions" appendTo="body"></p-dropdown>
  </div>
  <div class="ui-inputgroup" id="sampleCauseDropDown">
    <button pButton class="theme-button noHover labelButton" type="button" label="Comment"></button>
    <textarea pInputTextarea rows="2" cols="30" [(ngModel)]="comment"
      placeholder="Enter comments related to sample"></textarea>
  </div>
  <p-footer>
    <button pButton id="doneNonConform" label="Save" (click)="hideNonConformPopUp()"
      [disabled]="sampleSaveDisable"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Error in Scan Save" [(visible)]="showSaveScanErrorPopUp" [modal]="true">
  <label class="font-weight-bold text-danger">
    {{saveScanErrorBody}}
  </label>
  <p-footer>
    <button pButton type="button" label="OK" (click)="closeScanSaveErrorPopUp()"></button>
  </p-footer>
</p-dialog>


<p-dialog [header]="saveScanErrorHeader" [closable]="false" [(visible)]="showScanDialog" [modal]="true" (onShow)="setLabelFocus(error)"
  (onHide)="focusDeciderAfterHide()">
  <textarea #error type="text" rows="4" cols="50" class="font-weight-bold text-danger" readonly>
    {{saveScanErrorBody}}
  </textarea>
  <p-footer>
    <button pButton type="button" label="OK" (click)="closeScanErrorPopUp()"></button>
  </p-footer>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<p-dialog [(visible)]="scanPlatePopup" [modal]="true" showEffect="fade" [style.width]="'1200px'" position="top" header="Sample - Scan" baseZIndex="5">
  <div *ngIf = "!isCreate && scanPlatePopup">
  <span style = "float : left">
    External-Plate-ID : {{selectedBatch.externalIdentification}}
    <br>
    Internal- Plate-ID : {{selectedBatch.batchID}}
  </span>
  <span style = "float : right">
    <button pButton id="startScan" label="Start Scan" (click)="startScan()"
    ></button>
  </span>
  <div *ngIf = "!startScanClicked" class="col-12 flex p-0">
    <app-plate-view  [selectedBatch]="selectedBatch" [puid]="puid" [selectedLabId]="selectedLabId" [totalPCRControls]="totalPCRControls"
     [showPlateView]="showPlateView" [viewMode]="plateViewMode" [sourceBatchSamplesMap]="sourceBatchSamplesMap"></app-plate-view>
  </div>
  <div *ngIf = "startScanClicked" class="col-12 flex p-0">
    <app-plate-view  [selectedBatch]="selectedBatch" [puid]="puid" [selectedLabId]="selectedLabId" [totalPCRControls]="totalPCRControls"
     [showPlateView]="showPlateView" [viewMode]="plateViewMode" [sourceBatchSamplesMap]="sourceBatchSamplesMap"></app-plate-view>
  </div>
    <button pButton id="scanPopupsave" label="Save" (click)="saveScanComplete()"
      [disabled]="sampleSaveDisable"></button>
</div>
</p-dialog>
